import React from 'react'

const AnalyticsSync = () => {
  return null
}

export default AnalyticsSync
